// --- External Libraries
import moment from 'moment-timezone';
// --- Components
import { CustomHeader } from 'datastage/components/AGGrid/cell-renderers/custom-header';
import { PillboxCellRenderer } from 'datastage/components/AGGrid/cell-renderers/pillbox';


export const id = {
    field: 'id',
    headerName: 'ID',
    width: 100,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'users',
    }
};

export const username = {
    field: 'username',
    headerName: 'Email Address',
    width: 350,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'username',
        page: 'users',
    }
};

export const fullName = {
    field: 'fullName',
    headerName: 'Name',
    width: 350,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'fullName',
        page: 'users',
    }
};

export const lastLogin = {
    field: 'lastLogin',
    headerName: 'Last Login',
    valueFormatter: ({ value }) => (value 
        ? moment.utc(value).tz(moment.tz.guess()).format('MM/DD/YYYY, h:mm:ss A z') 
        : ''),
    width: 350,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'lastLogin',
        page: 'users',
    }
};

export const status = {
    field: 'status',
    headerName: 'Status',
    width: 150,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'status',
        page: 'users',
    }
};

export const spaUserRoleIds = {
    field: 'spaUserRoleIds',
    headerName: 'Roles',
    cellRenderer: PillboxCellRenderer(),
    width: 800,
    autoHeight: true,
    wrapText: true,
};

export const rightslineId = {
    field: 'rightslineId',
    headerName: 'Rightsline ID',
    width: 205,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'rightslineId',
        page: 'users',
    }
};